<template>
  <div>
    <Mainl @mlogin="mlogin" @scrollTo="scrollTo"></Mainl>
    <div class="page_content">
      <div class="my-project-content">
        <div class="my-project-tabs">
          <el-radio-group class="my-project-tabs-group" v-model="tabType" @change="initList">
            <el-radio-button label="1">需求广场（{{ tabTypeOrderNum.demandSquare }}）</el-radio-button>
            <el-radio-button label="2">待执行（{{ tabTypeOrderNum.toBeExecuted }}）</el-radio-button>
            <el-radio-button label="3">执行中（{{ tabTypeOrderNum.inExecution }}）</el-radio-button>
            <el-radio-button label="4">待验收（{{ tabTypeOrderNum.waitingAccept }}）</el-radio-button>
            <el-radio-button label="5">已完成（{{ tabTypeOrderNum.done }}）</el-radio-button>
            <el-radio-button label="6">已取消（{{ tabTypeOrderNum.cancelled }}）</el-radio-button>
          </el-radio-group>
        </div>
        <!-- 需求广场 -->
        <div v-if="tabType == 1" class="my_project_demand">
          <div v-for="(item,index) in tableData" class="my_project_demand_card" :key="index" v-show="tableData.length > 0">
            <div class="my_project_demand_card_title" :title="item.project_name">{{ item.project_name }}</div>
            <div class="my_project_demand_card_content">
              <div class="my_project_demand_card_content_item">
                <div class="my_project_demand_card_content_label">
                  <span></span>需求描述
                </div>
                <div class="my_project_demand_card_content_desc">
                  <el-tooltip class="item" effect="dark" :content="item.requirement" placement="top">
                    <span style="-webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden; text-overflow: ellipsis;">{{ item.requirement }}</span>
                  </el-tooltip>
                </div>
              </div>
              <div class="my_project_demand_card_content_item">
                <div class="my_project_demand_card_content_label">
                  <span></span>所选SKU
                </div>
                <div class="my_project_demand_card_content_desc">
                  <!--
                  <span v-for="(val, key) in item.goods_info" :key="key">{{ val.goods_name }}（{{ val.goods_count }}个）<span v-if="key < (Object.keys(item.goods_info).length - 1)">、</span></span>
                  -->
                  <el-tooltip class="item" effect="dark" :content="item.goods_info_str" placement="top">
                    <span>{{item.goods_info_str}}</span>
                  </el-tooltip>
                </div>
              </div>
              <div class="my_project_demand_card_content_item" v-show="item.notes != ''">
                <div class="my_project_demand_card_content_label">
                  <span></span>备注
                </div>
                <div class="my_project_demand_card_content_desc">
                  {{ item.notes }}
                </div>
              </div>
              <div class="my_project_demand_card_content_item">
                <div class="my_project_demand_card_content_label">
                  <span></span>附件说明
                </div>
                <div class=" my_project_demand_card_content_desc my_project_demand_card_content_file" v-if="item.annex_info">
                  <a :href="val.url" target="_blank" v-for="(val, key) in item.annex_info[item.order_id]" :key="key">{{ val.filename }}</a>
                </div>
                <div class=" my_project_demand_card_content_desc my_project_demand_card_content_file" v-else>
                </div>
              </div>
            </div>
            <div class="my_project_demand_card_btns">
              <el-popconfirm icon="13" placement="top" title="放弃您将无法再次报名该项目！确定要放弃么？" @confirm="sureGiveUpOrder">
                <el-button slot="reference" class="my_project_demand_card_btn_1" type="primary" @click="popConfirmClick(item)" plain>放弃</el-button>
              </el-popconfirm>
              <el-button @click="registerOrderDialog(item, 1)" class="my_project_demand_card_btn_2" type="primary">报名</el-button>
            </div>
          </div>
          <div class="empty_project_demand" style="margin: auto" v-show="tableData.length == 0">
            <img :src="require('@/assets/img/shopping_cart_empty.png')" style="margin-top: 20px;"/>
            <p style="text-align: center">暂时没有待报名需求～</p>
          </div>
        </div>
        <el-dialog custom-class="my_project_demand_modal" :title="orderRegisterInfo.orderServiceType == 2 ? '关联案例' : '报名'" :visible.sync="dialogVisible" width="680px" @closed="handleClose" :close-on-click-modal="false">
          <div class="my_project_demand_modal_list">
            <div class="my_project_demand_modal_list_title">
              {{ orderRegisterInfo.projectName }}
            </div>
            <div class="my_project_demand_modal_list_desc">
              您必须至少关联一个相关案例才能提交报名，关联多个案例有助于客户更好的了解您的擅长业务。
            </div>
            <div class="my_project_demand_modal_list_wrap">
              <div v-for="(item,index) in orderRegisterInfo.caseData" class="my_project_demand_modal_list_item" :class="in_array(item.case_id, orderRegisterInfo.checkedCaseId) ? 'my_project_demand_modal_list_item_select' : ''" :key="index" @click="checkCase(item)">
                <img :src="item.case_cover" />
                <div class="my_project_demand_modal_list_item_info">
                  <div class="my_project_demand_modal_list_item_info_name">
                    <el-tooltip class="item" effect="dark" :content="item.name" placement="bottom">
                      <span style="overflow: hidden; max-width: 180px; height: 22px; white-space: nowrap; text-overflow: ellipsis;">{{ item.name }}</span>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" :content="item.category_top_name" placement="bottom">
                      <span class="my_project_demand_modal_list_item_info_tag" style="overflow: hidden; max-width: 80px; height: 22px; white-space: nowrap; text-overflow: ellipsis;">{{ item.category_top_name }}</span>
                    </el-tooltip>
                  </div>
                  <div class="my_project_demand_modal_list_item_info_type">
                    {{ item.category_second_name }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="my_project_demand_modal_footer">
            <span>已选择{{orderRegisterInfo.checkedCaseId.length}}个案例</span>
            <el-button style="width: 104px;height: 40px;" class="my_project_demand_card_btn_2" type="primary" @click="sureRegisterOrder">{{orderRegisterInfo.orderServiceType == 2 ? '确定关联' : '报名'}}</el-button>
          </div>
        </el-dialog>
        <!-- 待执行 -->
        <div v-if="tabType == 2" class="my_project_implement">
          <div class="my_project_implement_filter">
            <div class="my_project_implement_filter_item">
              <span>订单状态：</span>
              <el-select v-model="checkedOrderStatus" @change="initList">
                <el-option v-for="item in inExecutionOrderStatusDic" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="my_project_implement_filter_item">
              <span>报名时间：</span>
              <el-date-picker v-model="registerDate" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions" :editable="false" @change="initList">
              </el-date-picker>
            </div>
          </div>
          <el-table :data="tableData" style="width: 100%" class="order_table">
            <el-table-column width="360" prop="id" label="项目名称">
              <template slot-scope="scope">
                <div class="my_project_implement_table_name">{{ scope.row.project_name }}</div>
                  <p class="my_project_implement_table_desc margin0 multi-text2">
                    <el-tooltip class="item" effect="dark" :content="scope.row.requirement" placement="top">
                      <span style="-webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden; text-overflow: ellipsis;">{{ scope.row.requirement }}</span>
                    </el-tooltip>
                  </p>
              </template>
            </el-table-column>
            <el-table-column width="360" prop="category" label="所选SKU">
              <template slot-scope="scope">
                <p class="my_project_implement_table_desc">
                  <!--
                  <span v-for="(val, key) in scope.row.goods_info" :key="key">{{ val.goods_name }}（{{ val.goods_count }}个）<span v-if="key < (Object.keys(scope.row.goods_info).length - 1)">、</span></span>
                  -->
                  <el-tooltip class="item" effect="dark" :content="scope.row.goods_info_str" placement="top">
                    <span>{{scope.row.goods_info_str}}</span>
                  </el-tooltip>
                </p>
              </template>
            </el-table-column>
            <el-table-column prop="order_status" align="center" label="订单状态">
              <template slot-scope="scope">
                <span class="implement_tag" v-if="scope.row.order_status == 4">待执行</span>
                <span class="candidate_tag" v-if="scope.row.order_status == 3">候选中</span>
              </template>
            </el-table-column>
            <el-table-column prop="register_time_str" label="报名时间" align="center">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" :content="scope.row.register_time_str" placement="top">
                  <div>{{scope.row.register_time_str}}</div>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="count" label="操作" width="148" align="center">
              <template slot-scope="scope">
                <div class="my_project_implement_table_operation">
                  <el-popconfirm icon="13" placement="top" title="放弃您将无法再次报名该项目！确定要放弃么？" @confirm="sureGiveUpOrder">
                    <el-button style="padding: 5px 0;" slot="reference" type="text" v-show="scope.row.order_status == 3" @click="popConfirmClick(scope.row)">放弃</el-button>
                  </el-popconfirm>
                  <el-button @click="uploadOrderFileDialog(scope.row)" type="text">上传附件</el-button>
                  <el-button style="margin:  0;" type="text"  @click="registerOrderDialog(scope.row, 2)">关联案例</el-button>
                  <el-button style="margin:  0;" type="text" @click="goDetail(scope.row.order_id)">详情</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-dialog custom-class="my_project_demand_modal" title="上传附件" :visible.sync="dialogVisible3" width="680px" :before-close="handleClose3" :close-on-click-modal="false">
          <div class="my_project_demand_attachment">
            <div class="my_project_demand_attachment_title">{{uploadOrderFileInfo.projectName}}</div>
            <div class="my_project_demand_attachment_table">
              <el-table :data="uploadOrderFileInfo.fileData" style="width: 100%" class="order_table" v-loading="isUploading" element-loading-text="文件上传中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                <el-table-column width="240" align="center" prop="file" label="附件名称">
                  <template slot-scope="scope">
                    <a class="my_project_demand_attachment_upload_name" :href="scope.row.url" target="_blank" v-if="scope.row.url">
                      {{scope.row.filename}}
                    </a>
                    <el-upload
                        :show-file-list="false"
                        :action="pubPrefix+upload_url"
                        v-else
                        class="upload-demo"
                        name="order_files"
                        :limit="1"
                        :on-change="handleFileChange"
                        :data="{upload_type: '5'}"
                        :on-success="handleFIleSuccess"
                        :before-upload="beforeFileUpload"
                        :on-progress="handleFileUploadProgress"
                        :disabled="isUploading"
                        :headers="upload_headers"
                        accept=".pdf, .ppt, .docx, .jpg, .jpeg, .png, .pptx "
                        >
                      <div class="my_project_demand_attachment_upload_btn">
                        <i class="el-icon-circle-plus" style="color: #4573FF;"></i>
                        上传
                      </div>
                    </el-upload>
                  </template>
                </el-table-column>
                <el-table-column width="240" align="center" prop="annex_desc" label="附件说明">
                  <template slot-scope="scope">
                    <el-input  style="width: 102px;" @change="orderFileDescChange" size="small" maxlength="10" v-if="scope.row.url" v-model="scope.row.annex_desc" placeholder="最多10个字符"></el-input>
                  </template>
                </el-table-column>
                <el-table-column width="120" align="center" label="操作">
                  <template slot-scope="scope">
                    <img class="my_project_demand_attachment_upload_del" v-if="scope.row.url" :src="require('@/assets/img/icon_delete_color.png')" @click="removeOrderFile(scope.$index)"/>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="my_project_demand_attachment_footer">
            <el-button style="width: 104px;height: 40px;" class="my_project_demand_card_btn_2" type="primary" @click="sureUploadOrderFile">确定上传</el-button>
          </div>
        </el-dialog>
        <!-- 执行中 -->
        <div v-if="tabType == 3" class="my_project_implement">
          <div class="my_project_implement_filter">
            <div class="my_project_implement_filter_item">
              <span>执行开始时间：</span>
              <el-date-picker v-model="executionDate" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions" :editable="false" @change="initList">
              </el-date-picker>
            </div>
          </div>
          <el-table :data="tableData" style="width: 100%" class="order_table">
            <el-table-column width="360" prop="id" label="项目名称">
              <template slot-scope="scope">
                <div class="my_project_implement_table_name">{{ scope.row.project_name }}</div>
                <p class="my_project_implement_table_desc margin0 multi-text2">
                  <el-tooltip class="item" effect="dark" :content="scope.row.requirement" placement="top">
                    <span style="-webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden; text-overflow: ellipsis;">{{ scope.row.requirement }}</span>
                  </el-tooltip>
                </p>
              </template>
            </el-table-column>
            <el-table-column width="360" prop="category" label="所选SKU">
              <template slot-scope="scope">
                <p class="my_project_implement_table_desc">
                  <!--
                  <span v-for="(val, key) in scope.row.goods_info" :key="key">{{ val.goods_name }}（{{ val.goods_count }}个）<span v-if="key < (Object.keys(scope.row.goods_info).length - 1)">、</span></span>
                  -->
                  <el-tooltip class="item" effect="dark" :content="scope.row.goods_info_str" placement="top">
                    <span>{{scope.row.goods_info_str}}</span>
                  </el-tooltip>
                </p>
              </template>
            </el-table-column>
            <el-table-column prop="execution_time_str" label="执行开始时间" align="center"> </el-table-column>
            <el-table-column prop="count" label="操作" width="148" align="center">
              <template slot-scope="scope">
                <div class="my_project_implement_table_operation">
                  <el-popconfirm icon="13" placement="top" title="确定项目已经执行完成吗？" @confirm="sureCompleteOrder" v-show="scope.row.service_complete_time <= 0">
                    <el-button style="padding: 5px 0;" slot="reference" type="text" @click="popConfirmClick(scope.row)">完成</el-button>
                  </el-popconfirm>
                  <el-button style="margin:  0;" type="text" @click="goDetail(scope.row.order_id)">详情</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 待验收 -->
        <div v-if="tabType == 4" class="my_project_implement">
          <el-table :data="tableData" style="width: 100%" class="order_table">
            <el-table-column width="330" prop="id" label="项目名称">
              <template slot-scope="scope">
                <div class="my_project_implement_table_name">{{ scope.row.project_name }}</div>
                <p class="my_project_implement_table_desc margin0 multi-text2">
                  <el-tooltip class="item" effect="dark" :content="scope.row.requirement" placement="top">
                    <span style="-webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden; text-overflow: ellipsis;">{{ scope.row.requirement }}</span>
                  </el-tooltip>
                </p>
              </template>
            </el-table-column>
            <el-table-column width="330" prop="category" label="所选SKU">
              <template slot-scope="scope">
                <p class="my_project_implement_table_desc">
                  <!--
                  <span v-for="(val, key) in scope.row.goods_info" :key="key">{{ val.goods_name }}（{{ val.goods_count }}个）<span v-if="key < (Object.keys(scope.row.goods_info).length - 1)">、</span></span>
                  -->
                  <el-tooltip class="item" effect="dark" :content="scope.row.goods_info_str" placement="top">
                    <span>{{scope.row.goods_info_str}}</span>
                  </el-tooltip>
                </p>
              </template>
            </el-table-column>
            <el-table-column prop="execution_time_str" label="执行开始时间" width="188" align="center"> </el-table-column>
            <el-table-column prop="service_complete_time_str" label="执行完成时间" width="188" align="center"> </el-table-column>
            <el-table-column prop="count" label="操作" width="128" align="center">
              <template slot-scope="scope">
                <div class="my_project_implement_table_operation">
                  <el-button style="margin:  0;" type="text" @click="goDetail(scope.row.order_id)">详情</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 已完成 -->
        <div v-if="tabType == 5" class="my_project_implement">
          <el-table :data="tableData" style="width: 100%" class="order_table">
            <el-table-column width="330" prop="id" label="项目名称">
              <template slot-scope="scope">
                <div class="my_project_implement_table_name">{{ scope.row.project_name }}</div>
                <p class="my_project_implement_table_desc margin0 multi-text2">
                  <el-tooltip class="item" effect="dark" :content="scope.row.requirement" placement="top">
                    <span style="-webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden; text-overflow: ellipsis;">{{ scope.row.requirement }}</span>
                  </el-tooltip>
                </p>
              </template>
            </el-table-column>
            <el-table-column width="330" prop="category" label="所选SKU">
              <template slot-scope="scope">
                <p class="my_project_implement_table_desc">
                  <!--
                  <span v-for="(val, key) in scope.row.goods_info" :key="key">{{ val.goods_name }}（{{ val.goods_count }}个）<span v-if="key < (Object.keys(scope.row.goods_info).length - 1)">、</span></span>
                  -->
                  <el-tooltip class="item" effect="dark" :content="scope.row.goods_info_str" placement="top">
                    <span>{{scope.row.goods_info_str}}</span>
                  </el-tooltip>
                </p>
              </template>
            </el-table-column>
            <el-table-column prop="execution_time_str" label="执行开始时间"  width="188" align="center"> </el-table-column>
            <el-table-column prop="complete_time_str" label="完成时间"  width="188" align="center"> </el-table-column>
            <el-table-column prop="count" label="操作" width="128" align="center">
              <template slot-scope="scope">
                <div class="my_project_implement_table_operation">
                  <el-button style="margin:  0;" type="text" @click="goDetail(scope.row.order_id)">详情</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 已取消 -->
        <div v-if="tabType == 6" class="my_project_implement">
          <el-table :data="tableData" style="width: 100%" class="order_table">
            <el-table-column width="360" label="项目名称">
              <template slot-scope="scope">
                <div class="my_project_implement_table_name">{{ scope.row.project_name }}</div>
                <p class="my_project_implement_table_desc margin0 multi-text2">
                  <el-tooltip class="item" effect="dark" :content="scope.row.requirement" placement="top">
                    <span style="-webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden; text-overflow: ellipsis;">{{ scope.row.requirement }}</span>
                  </el-tooltip>
                </p>
              </template>
            </el-table-column>
            <el-table-column width="360" prop="category" label="所选SKU">
              <template slot-scope="scope">
                <p class="my_project_implement_table_desc">
                  <!--
                  <span v-for="(val, key) in scope.row.goods_info" :key="key">{{ val.goods_name }}（{{ val.goods_count }}个）<span v-if="key < (Object.keys(scope.row.goods_info).length - 1)">、</span></span>
                  -->
                  <el-tooltip class="item" effect="dark" :content="scope.row.goods_info_str" placement="top">
                    <span>{{scope.row.goods_info_str}}</span>
                  </el-tooltip>
                </p>
              </template>
            </el-table-column>
            <el-table-column prop="cancel_reason" label="取消原因" align="center"> </el-table-column>
            <el-table-column prop="cancel_time_str" label="取消时间"  width="188" align="center"> </el-table-column>
            <el-table-column prop="count" label="操作" width="128" align="center">
              <template slot-scope="scope">
                <div class="my_project_implement_table_operation">
                  <el-button style="margin:  0;" type="text" @click="goDetail(scope.row.order_id)">详情</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Mainl from '@/components/Mainl.vue'
// import axios from 'axios'
// import Cookies from 'js-cookie'
// eslint-disable-next-line
import * as commfun from '@/common/common.js'
import Cookies from 'js-cookie'
var pubPrefix = '/api'
let defaultAttachment = {
  filename: '',
  url: '',
  annex_desc: '',
  id: 0
}
export default {
  name: "MyProject",
  components: {
    Mainl
  },
  data: function () {
    return {
      pickerOptions:{
        /*
        disabledDate: (time) => {
          return time.getTime() < new Date(new Date().toLocaleDateString()).getTime();
        }
        */
      },
      tabType: 1,  // 页签
      tabTypeOrderNum: {
        demandSquare: 0,  // 需求广场
        toBeExecuted: 0,  // 待执行
        inExecution: 0,  // 执行中
        waitingAccept: 0,  // 待验收
        done: 0,  // 已完成
        cancelled: 0  // 已取消
      },
      tableData: [],
      popConfiremOrderInfo: {
        orderId: ''
      },
      subFlag: true,
      dialogVisible: false,
      dialogVisible3: false,
      orderRegisterInfo: { // 订单报名信息
        orderId: '',
        projectName: '',
        orderServiceType: 1,
        caseData: [],
        checkedCaseId: []
      },
      inExecutionOrderStatusDic: [
        {
          value: 0,
          label: '全部'
        },
        {
          value: 3,
          label: '候选中'
        },
        {
          value: 4,
          label: '待执行'
        },
      ],
      checkedOrderStatus: 0,
      registerDate: [],  // 报名时间
      uploadOrderFileInfo: {
        orderId: '',
        projectName: '',
        fileData: [],  // 只包含文件名/地址/描述
        fileDetailData: []  // 包含文件的详细信息
      },
      isUploading: false,
      upload_url: '/api/index/upload',
      upload_headers: {},
      pubPrefix: pubPrefix,
      executionDate: [],  // 执行时间
    }
  },
  created () {

  },
  mounted () {
    // 获取token设置header
    var Authorization = commfun.genAuthorization()
    this.upload_headers = {'Authorization': Authorization}
    this.initList()
  },
  methods: {
    // 列表数据
    initList: function () {
      var selfthis = this
      var url = pubPrefix + '/api/order/serviceOrderList'
      if (this.tabType != 2) {
        this.checkedOrderStatus = 0
        this.registerDate = []
      }
      if (this.tabType != 3) {
        this.executionDate = []
      }
      var registerStartDate = '',
          registerEndDate = '',
          executionStartDate = '',
          executionEndDate = ''
      if (this.registerDate != null && this.registerDate.length > 0) {
        registerStartDate = this.registerDate[0]
        registerEndDate = this.registerDate[1]
      }
      if (this.executionDate != null && this.executionDate.length > 0) {
        executionStartDate = this.executionDate[0]
        executionEndDate = this.executionDate[1]
      }
      var postdata = {tabType: this.tabType, orderStatus: this.checkedOrderStatus, registerStartDate, registerEndDate, executionStartDate, executionEndDate}
      commfun.ajaxPost(selfthis, url, postdata, function (selfthis, data) {
        if (data.orderData == null || data.orderData === undefined) {
          selfthis.tableData = []
        } else {
          for (var k in data.orderData) {
            var goods_info_str = ''
            if (Object.keys(data.orderData[k].goods_info).length > 0) {  // data.orderData[k].goods_info.length > 0
              for (var j in data.orderData[k].goods_info) {
                goods_info_str += data.orderData[k].goods_info[j].goods_name + '（' + data.orderData[k].goods_info[j].goods_count + '个）、'
              }
            }
            if (goods_info_str != '') {
              goods_info_str = goods_info_str.slice(0, -1)
            }
            data.orderData[k].goods_info_str = goods_info_str
          }
          // 执行中订单按执行开始时间正序排序
          if (selfthis.tabType == 3) {
            let orderedData = data.orderData
            orderedData.sort((a, b) => {
              if (a.execution_time !== b.execution_time) {
                return a.execution_time - b.execution_time;
              }
            });
            selfthis.tableData = orderedData
          } else if (selfthis.tabType == 4) {  // 待验收列表按执行完成时间倒序排序
            let orderedData = data.orderData
            orderedData.sort((a, b) => {
              if (a.service_complete_time !== b.service_complete_time) {
                return a.service_complete_time - b.service_complete_time;
              }
            });
            selfthis.tableData = orderedData
          } else if (selfthis.tabType == 5) {  // 已完成列表按完成时间倒序排序
            let orderedData = data.orderData
            orderedData.sort((a, b) => {
              if (a.complete_time !== b.complete_time) {
                return a.complete_time - b.complete_time;
              }
            });
            selfthis.tableData = orderedData
          } else if (selfthis.tabType == 1) {  // 需求广场，能报名的在上面显示，不能报名的在下面显示
            let orderedData = data.orderData
            orderedData.sort((a, b) => {
              if (a.can_applicate === b.can_applicate) {
                return b.order_id - a.order_id; // 如果可以报名，按下单时间降序排列
              } else {
                return b.can_applicate - a.can_applicate; // 按是否可以报名降序排列
              }
            });
            selfthis.tableData = orderedData
          } else {
            selfthis.tableData = data.orderData
          }
        }
        if (data.tabTypeData != undefined) {
          selfthis.tabTypeOrderNum = data.tabTypeData
        }
        selfthis.subFlag = true
      }, function (selfthis, dataError) {
        commfun.showMessage(selfthis, 'warning', '错误：' + dataError.msg)
      })
    },
    handleClose(done) {
      this.dialogVisible = false
      this.orderRegisterInfo.orderServiceType = 1
    },
    handleClose3(done) {
      this.dialogVisible3 = false
    },
    // 放弃订单气泡框弹出
    popConfirmClick (item) {
      this.popConfiremOrderInfo.orderId = item.order_id
      console.log(item)
    },
    // 确认放弃订单
    sureGiveUpOrder () {
      if (this.popConfiremOrderInfo.orderId == '') {
        commfun.showMessage(selfthis, 'error', '缺少订单ID参数，请联系管理员！')
        return
      }
      if (!this.subFlag) {
        return
      }
      this.subFlag = false
      var selfthis = this
      var url = pubPrefix + '/api/order/serviceGiveUpOrder'
      var postdata = {order_id: this.popConfiremOrderInfo.orderId}
      commfun.ajaxPost(selfthis, url, postdata, function (selfthis, data) {
        selfthis.initList()
      }, function (selfthis, dataError) {
        selfthis.subFlag = true
        commfun.showMessage(selfthis, 'warning', '错误：' + dataError.msg)
      })
    },
    // 报名订单弹框 type:1：报名【需要添加order_service数据】  2：关联案例【只添加材料表数据】
    registerOrderDialog (item, type) {
      var selfthis = this
      if (type == 1) {
        if (item.order_status > 3) {
          commfun.showMessage(selfthis, 'warning', '该需求已选定服务商!')
          return
        }
      }
      selfthis.orderRegisterInfo.projectName = item.project_name
      selfthis.orderRegisterInfo.orderServiceType = type
      selfthis.orderRegisterInfo.orderId = item.order_id
      //selfthis.dialogVisible = true
      // 查询服务方所有案例和当前订单已关联案例 M2024123102请上传三个案例后再进行报名
      var url = pubPrefix + '/api/order_material/getRegisterOrderCases'
      var postdata = {order_id: item.order_id}
      commfun.ajaxPost(selfthis, url, postdata, function (selfthis, data) {
        if (data.length <3) {
          commfun.showMessage(selfthis, 'warning', '请上传三个案例后再进行报名!')
          return false;
        }
        selfthis.dialogVisible = true
        selfthis.orderRegisterInfo.caseData = data
        selfthis.orderRegisterInfo.checkedCaseId = [];
        for (var i = 0; i < data.length; i ++) {
          if (data[i].is_checked == true) {
            selfthis.orderRegisterInfo.checkedCaseId.push(data[i].case_id)
          }
        }
      }, function (selfthis, dataError) {
        commfun.showMessage(selfthis, 'warning', '错误：' + dataError.msg)
      })
    },
    // 报名弹框选择案例
    checkCase (item) {
      if (this.in_array(item.case_id, this.orderRegisterInfo.checkedCaseId)) {
        this.orderRegisterInfo.checkedCaseId = this.orderRegisterInfo.checkedCaseId.filter(element => element !== item.case_id);
      } else {
        this.orderRegisterInfo.checkedCaseId.push(item.case_id)
      }
    },
    // 确认报名按钮
    sureRegisterOrder () {
      var selfthis = this
      if (this.orderRegisterInfo.orderId == '') {
        commfun.showMessage(selfthis, 'error', '缺少订单ID参数，请联系管理员！')
        return
      }
      if (this.orderRegisterInfo.checkedCaseId.length == 0) {
        commfun.showMessage(selfthis, 'error', '您必须至少关联一个相关案例！')
        return
      }
      if (!this.subFlag) {
        return
      }
      this.subFlag = false
      var caseIds = this.orderRegisterInfo.checkedCaseId.join(',')
      var url = pubPrefix + '/api/order/serviceRegisterOrder'
      var postdata = {order_id: this.orderRegisterInfo.orderId, case_ids: caseIds, order_service_type: this.orderRegisterInfo.orderServiceType}
      commfun.ajaxPost(selfthis, url, postdata, function (selfthis, data) {
        selfthis.dialogVisible = false
        var msg = '项目报名'
        if (selfthis.orderRegisterInfo.orderServiceType == 2) {
          msg = '关联案例'
          selfthis.subFlag = true
          selfthis.dialogVisible = false
        } else {
          selfthis.initList()
        }
        commfun.showMessage(selfthis, 'success', msg + "成功！")
      }, function (selfthis, dataError) {
        selfthis.subFlag = true
        commfun.showMessage(selfthis, 'warning', '错误：' + dataError.msg)
      })
    },
    // 订单上传附件弹框
    uploadOrderFileDialog (item) {
      var selfthis = this
      selfthis.uploadOrderFileInfo.projectName = item.project_name
      selfthis.uploadOrderFileInfo.orderId = item.order_id
      selfthis.dialogVisible3 = true
      // 查询服务方所有案例和当前订单已关联案例
      var url = pubPrefix + '/api/order_material/getRegisterOrderFiles'
      var postdata = {order_id: item.order_id}
      commfun.ajaxPost(selfthis, url, postdata, function (selfthis, data) {
        selfthis.uploadOrderFileInfo.fileData = []
        selfthis.uploadOrderFileInfo.fileDetailData = []
        if (data.length > 0) {
          selfthis.uploadOrderFileInfo.fileData = data
          var copyData = Object.assign([], data);
          selfthis.uploadOrderFileInfo.fileDetailData = copyData
        }
        selfthis.uploadOrderFileInfo.fileData.push(defaultAttachment)
      }, function (selfthis, dataError) {
        commfun.showMessage(selfthis, 'warning', '错误：' + dataError.msg)
      })
    },
    handleFileChange(file, fileList) {
    },//上传文件
    handleFileUploadProgress (event, file, fileList) {
      this.isUploading = true;
    },
    // 上传完成
    async handleFIleSuccess(res, file, fileList) {
      var selfthis = this
      if (res.code != 1000) {
        selfthis.isUploading = false;
        fileList.pop()
        if (res.msg != undefined && res.msg != '') {
          this.$message.error(res.msg);
        }
        return false;
      }
      res.data.status="success"
      res.data.name=file.name
      res.data.url=res.data.fileurl
      res.data.type = 1
      res.data.annex_desc = ''
      selfthis.uploadOrderFileInfo.fileDetailData.push(res.data)
      for (var j = 0; j < selfthis.uploadOrderFileInfo.fileData.length; j++) {
        if (selfthis.uploadOrderFileInfo.fileData[j].id != undefined && selfthis.uploadOrderFileInfo.fileData[j].id == 0) {
          selfthis.uploadOrderFileInfo.fileData.splice(j, 1);
          j--; // 由于删除了一个元素，需要将j减1，以便下一次循环时仍然指向正确的元素
        }
      }
      var temp = {}
      temp.url = res.data.url
      temp.filename = file.name
      temp.annex_desc = ""
      selfthis.uploadOrderFileInfo.fileData.push(temp)
      selfthis.uploadOrderFileInfo.fileData.push(defaultAttachment)
      selfthis.isUploading = false;
    },//handleFIleSuccess
    // 上传文件
    beforeFileUpload(file, fileList){
      // this.upload_data['_csrf-backend'] = csrfToken;
      const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);
      const whiteList = ["pdf", "ppt", "pptx", "docx", "jpg", "jpeg", "png", "PDF","PPT", "PPTX", "DOCX", "JPG", "JPEG", "PNG"];
      if (whiteList.indexOf(fileSuffix) === -1) {
        var msg = '只能上传pdf/ppt/docx/jpg/jpeg/png格式文件!'
        this.$message.error(msg);
        return false;
      }else{
        const isLt2M = file.size / 1024 / 1024 < 100;
        if (!isLt2M) {
          this.$message.error('上传文件大小不能超过 100MB!');
        }
        const isJPG = true;
        return isJPG && isLt2M;
      }
    },
    // 删除页面上传的附件
    removeOrderFile (index) {
      this.uploadOrderFileInfo.fileData.splice(index, 1);
      this.uploadOrderFileInfo.fileDetailData.splice(index, 1);
    },
    // 附件说明填写
    orderFileDescChange () {
      for (var i in this.uploadOrderFileInfo.fileData) {
        if (this.uploadOrderFileInfo.fileData[i].annex_desc != '') {
          this.uploadOrderFileInfo.fileDetailData[i].annex_desc = this.uploadOrderFileInfo.fileData[i].annex_desc
        }
      }
    },
    // 确认上传附件
    sureUploadOrderFile () {
      var selfthis = this
      if (this.uploadOrderFileInfo.orderId == '') {
        commfun.showMessage(selfthis, 'error', '缺少订单ID参数，请联系管理员！')
        return
      }
      if (this.uploadOrderFileInfo.fileDetailData.length == 0) {
        commfun.showMessage(selfthis, 'error', '请上传附件！')
        return
      }
      if (this.isUploading) {
        commfun.showMessage(selfthis, 'warning', '附件上传中，请稍后！')
        return
      }
      //附件
      var order_files = ''
      var file_list = selfthis.uploadOrderFileInfo.fileDetailData
      if (file_list) {
        for (var j = 0; j < file_list.length; j++) {
          if (file_list[j]['url']) {
            file_list[j]['url1'] = encodeURIComponent(file_list[j]['url'])
            order_files +=   file_list[j]['annex'] + '|' + file_list[j]['hash'] + '|' + file_list[j]['type'] + '|' + file_list[j]['filename'] + '|' + file_list[j]['filesize'] + '|' + file_list[j]['url1'] + '|' + file_list[j]['uid'] + '|' + file_list[j]['username'] + '|' + file_list[j]['datetime'] + '|' + file_list[j]['annex_desc'] + ',';
          } else {
            var file_temp = file_list[j]['response']['data']
            file_temp['url1'] = encodeURIComponent(file_temp['url'])
            order_files +=   file_temp['annex'] + '|' + file_temp['hash'] + '|' + file_temp['type'] + '|' + file_temp['filename'] + '|' + file_temp['filesize'] + '|' + file_temp['url1'] + '|' + file_temp['uid'] + '|' + file_temp['username'] + '|' + file_temp['datetime'] + '|' + file_temp['annex_desc'] + ',';
          }
        }
        order_files = order_files.slice(0, order_files.length - 1);
      }
      if (!this.subFlag) {
        return
      }
      this.subFlag = false
      var url = pubPrefix + '/api/order/serviceUploadOrderFile'
      var postdata = {order_id: this.uploadOrderFileInfo.orderId, order_files}
      commfun.ajaxPost(selfthis, url, postdata, function (selfthis, data) {
        selfthis.dialogVisible3 = false
        selfthis.subFlag = true
        commfun.showMessage(selfthis, 'success', "上传附件成功！")
      }, function (selfthis, dataError) {
        selfthis.subFlag = true
        commfun.showMessage(selfthis, 'warning', '错误：' + dataError.msg)
      })
    },
    // 服务商确认完成项目
    sureCompleteOrder () {
      if (this.popConfiremOrderInfo.orderId == '') {
        commfun.showMessage(selfthis, 'error', '缺少订单ID参数，请联系管理员！')
        return
      }
      if (!this.subFlag) {
        return
      }
      this.subFlag = false
      var selfthis = this
      var url = pubPrefix + '/api/order/serviceCompleteOrder'
      var postdata = {order_id: this.popConfiremOrderInfo.orderId}
      commfun.ajaxPost(selfthis, url, postdata, function (selfthis, data) {
        selfthis.initList()
      }, function (selfthis, dataError) {
        selfthis.subFlag = true
        commfun.showMessage(selfthis, 'warning', '错误：' + dataError.msg)
      })
    },
    // 订单详情
    goDetail (orderId) {
      window.open('/myprojectdetail?order_id=' + orderId)
    },

    mlogin: function (type) {
      if (type === 'example') {
        this.visible = true
      } else {
        this.visible2 = true
      }
    },
    scrollTo: function (type) { // 滚动到位置 锚点
      document.querySelector('#' + type).scrollIntoView(true)
    },
    // 判断指定值是否在指定数组中
    in_array (search, array) {
      for (var i = 0; i < array.length; i++) {
        if (array[i] === search) {
          return true;
        }
      }
      return false;
    },
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/MyProject.vue